new Swiper('.carousel-home__element__alone', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  slidesPerView: 'auto',
  // navigation: {
  //   nextEl: '.carousel-element__navigation .swiper-button-next',
  //   prevEl: '.carousel-element__navigation .swiper-button-prev',
  // },

  pagination: {
    el: '.carousel-element__alone__pagination .swiper-pagination',
    clickable: true,
    renderBullet: function renderBullet(index, className) {
      return '<span class="' + className + '"> 0' + (index + 1) + '</span>';
    }
  }
});
new Swiper('.carousel-home__image__element', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.carousel-element__navigation .swiper-button-next',
    prevEl: '.carousel-element__navigation .swiper-button-prev'
  },
  pagination: {
    el: '.carousel-element__pagination .swiper-pagination',
    clickable: true,
    renderBullet: function renderBullet(index, className) {
      return '<span class="' + className + '"> 0' + (index + 1) + '</span>';
    }
  }
});
new Swiper('.carousel-home__element', {
  // Optional parameters
  loop: true,
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.carousel-element__navigation .swiper-button-next',
    prevEl: '.carousel-element__navigation .swiper-button-prev'
  },
  pagination: {
    el: '.carousel-element__pagination .swiper-pagination',
    clickable: true,
    renderBullet: function renderBullet(index, className) {
      return '<span class="' + className + '"> 0' + (index + 1) + '</span>';
    }
  }
});